import {Navigate, Outlet} from "react-router-dom";
import {useAuth} from "../auth-context";

const AdminRoute = () => {
    const { authToken, user } = useAuth();
    const role = (user?.role || '').toLowerCase();

    if (!authToken) {
        return <Navigate to="/login" replace />;
    }

    if (role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default AdminRoute;
